module.exports = __webpack_public_path__ + "img/scroll13.886cd169.png";